import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import baseUi from 'lib/base-ui';
import '@99designs/common/jquery-plugins/media-query-label';
import globalNav from '@99designs/common/apps/global-nav';

// fetch polyfill for ie11
import 'whatwg-fetch';

// Fix https://www.cve.mitre.org/cgi-bin/cvename.cgi?name=2015-9251
// More: https://github.com/jquery/jquery/issues/2432
// Can be removed when on jQuery 3
jQuery.ajaxPrefilter(s => {
    s.contents.script = false;
});

// Initialise asimov-media-query-label outside dom ready check below.
// It has its own check and we want this to fire as early as possible.
$(document).mediaQueryLabel();

$(function() {
    baseUi();
    globalNav();
});



// WEBPACK FOOTER //
// ./src/js/page/base.js